import { CA_PD_AGENCIES } from './ca_pd_agencies.js';
const MAP = { DEPT: 'DEPARTMENT', DEP: 'DEPARTMENT', DEPARTMENTS: 'DEPARTMENT', SHERIFFS: 'SHERIFF', CNTY: 'COUNTY', CO: 'COUNTY',
    OFC: 'OFFICE', CALIF: 'CALIFORNIA', CA: 'CALIFORNIA' };
export function normalizeAgency(s) {
    let t = String(s ?? '').toUpperCase().replace(/&/g, ' AND ').replace(/['’`]/g, '').replace(/[^A-Z0-9]+/g, ' ').trim();
    t = t.replace(/\bP D\b/g, 'PD').replace(/\bS O\b/g, 'SO');
    return t.split(' ').filter(Boolean).map((x) => MAP[x] ?? x).filter((x) => x !== 'THE').join(' ');
}
const countyKey = (c) => normalizeAgency(String(c ?? '').replace(/\s+county\s*$/i, ''));
const REQUEST_PREFIX = /^\s*(request\s+police\s+report|tcr)\s*-?\s*/i;
const GENERIC_SHERIFF = new Set(['SHERIFF', 'SHERIFF OFFICE', 'SHERIFF DEPARTMENT', 'COUNTY SHERIFF', 'COUNTY SHERIFF OFFICE', 'COUNTY SHERIFF DEPARTMENT', 'SO', 'SD']);
const EXACT = new Map();
const PHRASES = [];
const SHERIFF_OF = new Map();
for (const a of CA_PD_AGENCIES.agencies) {
    for (const x of a.aliases) {
        EXACT.set(x, [...(EXACT.get(x) ?? []), { a, needsCounty: false }]);
        PHRASES.push({ alias: x, a, needsCounty: false });
    }
    for (const x of a.county_aliases) {
        EXACT.set(x, [...(EXACT.get(x) ?? []), { a, needsCounty: true }]);
        PHRASES.push({ alias: x, a, needsCounty: true });
    }
    if (a.type === 'sheriff' && a.county)
        SHERIFF_OF.set(countyKey(a.county), a);
}
PHRASES.sort((x, y) => y.alias.length - x.alias.length || (x.alias < y.alias ? -1 : 1));
function resolve(cands, county) {
    const fit = cands.filter((c) => !c.needsCounty || (county && countyKey(c.a.county) === county));
    const uniq = [...new Map(fit.map((c) => [c.a.id, c.a])).values()];
    if (uniq.length <= 1)
        return uniq[0] ?? null;
    const inCounty = uniq.filter((a) => !a.county || countyKey(a.county) === county);
    return inCounty.length === 1 ? inCounty[0] : 'AMBIGUOUS';
}
function within(text, county) {
    const padded = ` ${text} `;
    let best = null;
    for (const p of PHRASES) {
        if (best && p.alias.length < best.len)
            break;
        if (!padded.includes(` ${p.alias} `))
            continue;
        if (!best)
            best = { len: p.alias.length, cands: [] };
        best.cands.push(p);
    }
    return best ? resolve(best.cands, county) : null;
}
const cleanField = (v) => String(v ?? '').trim().split(/\s+-\s+/)[0].replace(/\(?\d{3}\)?[\s.-]*\d{3}[\s.-]*\d{0,4}/g, ' ').replace(/\s+/g, ' ').trim();
export function matchAgency(i) {
    if (!/^CA\b/i.test(String(i.state ?? '')))
        return { agency: null, reason: 'NOT_CA', text: null };
    const c = countyKey(i.county) || null;
    const f = normalizeAgency(cleanField(i.field));
    let ambiguous = false;
    const take = (hit, via) => {
        if (hit === 'AMBIGUOUS') {
            ambiguous = true;
            return null;
        }
        return hit ? { agency: hit, via } : null;
    };
    if (f) {
        const r = take(resolve(EXACT.get(f) ?? [], c), 'field') ?? (GENERIC_SHERIFF.has(f) && c && SHERIFF_OF.has(c) ? { agency: SHERIFF_OF.get(c), via: 'field' } : null)
            ?? take(within(f, c), 'field');
        if (r)
            return r;
    }
    for (const s of i.subjects ?? []) {
        const n = normalizeAgency(String(s ?? '').replace(REQUEST_PREFIX, ' '));
        const r = n ? take(within(n, c), 'subject') : null;
        if (r)
            return r;
    }
    return { agency: null, reason: ambiguous ? 'AMBIGUOUS' : f ? 'UNLISTED' : 'NO_AGENCY', text: f || null };
}
/** "LAPD reports take 8 months to a year" for the case's agency, when Neila's list has a wait for it; else null. */
export function expectedWait(m, tasks) {
    const r = matchAgency({ field: m.Police_Department__c, subjects: tasks.map((t) => t.Subject), county: m.litify_pm__lit_Matter_County__c, state: m.litify_pm__Matter_State__c });
    return r.agency && r.agency.wait_text ? `${r.agency.short} reports take ${r.agency.wait_text}` : null;
}
//# sourceMappingURL=agency.js.map